<template>
  <Section :title="title" :border="true">
    <template v-if="!add" #actions>
      <Button btn-class="btn-sm" type="new"  btn-text="label.add"  @click.prevent="addData"/>
    </template>
    <div >
      <div v-for="(checklist, index) in checklists" :key="checklist?.id" class="my-1 d-flex justify-content-between align-items-center p-2 rounded hover-effect">
        <CheckboxInput
            v-model="checklist.checked"
            :label="checklist?.title"
            @update:modelValue="changeStatus(checklist?.id,$event)"
            :is-required="false"
            :desc="showDelayAndReminderConfig(checklist)"
            :bottom="false"/>
        <div class="d-flex align-items-center">
          <button class="btn btn-icon btn-light-primary remove-btn me-2" @click="toggleChecklistAlertModal(index)">
            <i class="bi bi-gear-fill fs-2 "></i>
          </button>
          <button class="btn btn-icon btn-light-danger remove-btn" @click="removeElement(checklist?.id)">
            <i class="fas fa-times fs-2"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-if="add">
      <form id="kt_modal_form_project" @submit.prevent="addElement" class="form mt-5" >
        <div class="row">
          <Input
              :name="'element'"
              container-class="col-md-6 mb-5"
              type="text"
              :label="$t('label.title')"
              :isRequired="true"
              size="lg"
              v-model="formData.title"
          />
          <Input
              :name="`${id}-delay`"
              container-class="col-md-6 mb-5"
              type="number"
              :label="$t('tasks.label.delay')"
              :isRequired="false"
              size="lg"
              v-model="formData.delay_value"
              :IsInputGroup="true"
          >
            <template #default>
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :multiple="false"
                      :show-search="false"
                      name="task-delay"
                      label-class="form-label"
                      v-model="formData.delay_unit"
                      :isRequired="false"
                  >
                        <option v-for="delay in delayFrequencyEnum" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
            </template>
          </Input>
        </div>
        <div class="d-flex mt-5 flex-row-reverse">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="addData"></Button>
          <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :isLoading="loading"  ></Button>
        </div>
      </form>
    </div>
  </Section>
  <ReminderConfigModal id="checklist-alert-config-modal" :form="reminderData"  @addConfig="getCheckListConfig" />
</template>
<script setup>
import Button from '@/components/Button.vue';
import CheckboxInput from '@/components/CheckboxInput.vue';
import Input from '@/components/Input.vue';
import { useSwal } from '@/composables/useSwal';
import { computed,  ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Section from "@/Modules/Projects/components/Section.vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";
import ReminderConfigModal from "@/Modules/Projects/components/Modals/ReminderConfigModal.vue";

const props = defineProps({
  data: {type: Array, default: []},
  title: String

})

const store = useStore()
const route = useRoute()
const {showSwal} = useSwal()
const { locale } = useLocales()

const add = ref(false)
const loading = ref(false)
const formData = ref({
  title: "",
  task: route.params.id,
  delay_value: "",
  delay_unit: ""
})
const element = ref("")
const configCheckList = ref("")
const reminderData= ref({
  delay_value_alert: "",
  delay_unit_alert: "",
  delay_value_critical: "",
  delay_unit_critical: ""
})

const checklists = computed(() => store.getters['checklists/getChecklists'])
const delayFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

const addData = () => { add.value = !add.value}

const addElement = async () => {
    loading.value = true
    try{
      await store.dispatch('checklists/createChecklist', formData.value)
      store.dispatch('checklists/loadChecklists', route.params.id)
      loading.value = false
      add.value = false
      formData.value = {
        title: "",
        task: route.params.id,
        delay_value: "",
        delay_unit: ""
      }
    }catch(err){

    }
}

const removeElement = (id) => {
  showSwal(
      i18n.global.t('swal.checklist'),
      i18n.global.t('swal.checklist_text')
  ).then( async (result) => {
    if (result.value) {
      try{
        await store.dispatch('checklists/deleteChecklist', id)      
        store.dispatch('checklists/loadChecklists', route.params.id)
        loading.value = false
      }catch(err){

      }
    }
  });
}

const changeStatus = async (id,checked) => {
  try{
      await store.dispatch('checklists/changeChecklistStatus', {id: id, checked})      
      store.dispatch('checklists/loadChecklists', route.params.id)
      loading.value = false
    }catch(err){

    }
}

function toggleChecklistAlertModal(index) {
  configCheckList.value = index
  const oldData = checklists.value[configCheckList.value]
  if(oldData) {
    reminderData.value = { ...oldData }
  }
  $('#checklist-alert-config-modal').modal('toggle')
}

function getCheckListConfig(alertConfig) {
  checklists.value[configCheckList.value].delay_value_alert = alertConfig.delay_value_alert
  checklists.value[configCheckList.value].delay_unit_alert = alertConfig.delay_unit_alert
  checklists.value[configCheckList.value].delay_value_critical = alertConfig.delay_value_critical
  checklists.value[configCheckList.value].delay_unit_critical = alertConfig.delay_unit_critical
  store.dispatch('checklists/updateChecklist', checklists.value[configCheckList.value])
      .then()
      .finally(() => store.dispatch('checklists/loadChecklists', route.params.id))
}

function showDelayAndReminderConfig(checklist) {
  const criticalDelay = locale.value == 'fr' ? checklist.delay_unit_critical_fr : checklist.delay_unit_critical_en
  const sampleDelay = locale.value == 'fr' ? checklist.delay_unit_alert_fr : checklist.delay_unit_alert_en
  const delay = checklist.delay_unit ? checklist.delay_value + ' ' + checklist.delay_unit_formatted[locale.value] : ''
  const configAlert = checklist.delay_unit_alert ? checklist.delay_value_alert + ' ' + sampleDelay : ''
  const configCritical = checklist.delay_unit_critical ? checklist.delay_value_critical + ' ' + criticalDelay : ''
  const configAlertHtml = configAlert ? ` | <span class="text-warning"> <i class="fa fa-clock text-warning"></i> ${configAlert} </span>` : ''
  const configCriticalHtml = configAlert ? ` | <span class="text-danger"> <i class="fa fa-clock text-danger"></i> ${configCritical} </span>` : ''

  return `
    <small>
    ${delay} ${configAlertHtml} ${configCriticalHtml}
</small>
  `
}

onMounted(() => {
  store.dispatch('configs/loadFrequencyEnum')
})



</script>
<style>


.hover-effect {
  transition: background-color 0.3s ease;
}

.hover-effect:hover {
  background-color: #0072CE0D; /* Light red background */
}

.remove-btn {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hover-effect:hover .remove-btn {
  opacity: 1;
}

</style>